import { useTranslation } from 'next-i18next'
import { toast } from 'react-toastify'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ISavedCv } from 'data-transfers/dto'
import { ISavedCvRequest } from 'data-transfers/requests'

import { IUseMutation } from 'hooks/types'
import { cvKeys } from 'hooks/useCV/keys'

import { savedCvKeys } from './keys'
import { addSavedCv } from './savedCvs.service'

const useSaveCv = ({
  onSuccess,
  ...options
}: IUseMutation<ISavedCv, unknown, ISavedCvRequest>) => {
  const queryClient = useQueryClient()
  const { t } = useTranslation(['crm'])
  return useMutation(addSavedCv, {
    onSuccess: (data, variables, context) => {
      toast.success(t('project.toast.cvSaved', { ns: 'crm' }))
      queryClient.invalidateQueries(savedCvKeys.all)
      queryClient.invalidateQueries(cvKeys.all)
      onSuccess?.(data, variables, context)
    },
    ...options
  })
}

export default useSaveCv
